import { Link, styled } from '@lingoda/ui';

export const BannerLink = styled(Link)({
    fontWeight: 400,
});
